import React, { type MouseEvent, type ReactNode } from 'react';
import EmptyState from '@atlaskit/empty-state';
import Button from '@atlaskit/button/new';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { FormattedMessage, useIntl } from 'react-intl-next';
import messages from './messages';
import { type Props } from './types';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import errorImage from '../../../../view/empty-state/icons/error.svg';
import mountTrackerFactory from '../../../../common/analytics/mount-tracker-factory';
import ContactSupport from '../../common/contact-support';

const MountTracker = mountTrackerFactory('SpaceOrPageNotFound');

const SpaceOrPageNotFound = ({ showConnectSpaceDialog }: Props) => {
	const { formatMessage } = useIntl();

	const handleClick = (_: MouseEvent, analyticsEvent: UIAnalyticsEvent) => {
		fireUIAnalytics(analyticsEvent, 'spaceOrPageNotFoundCreateButton');
		showConnectSpaceDialog();
	};

	return (
		<>
			<EmptyState
				imageUrl={errorImage}
				imageWidth={71}
				header={formatMessage(messages.title)}
				description={
					<FormattedMessage
						{...messages.description}
						values={{
							link: (chunks: ReactNode) => <ContactSupport label={chunks} />,
						}}
					/>
				}
				primaryAction={
					<Button appearance="default" onClick={handleClick}>
						{formatMessage(messages.connectSpaceButton)}
					</Button>
				}
			/>
			<MountTracker />
		</>
	);
};

export default SpaceOrPageNotFound;
